export default "__VITE_ASSET__fb9d1ad0__"